import React from "react";
import Field from "./Field";
import RadioButtonListControl from "./RadioButtonListControl";
import { RadioButtonListFieldProps } from "./Types";

const RadioButtonListField: React.FC<RadioButtonListFieldProps> = ({ labelProps, controlProps, visible, disabled, layout, options }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <RadioButtonListControl {...controlProps} disabled={disabled} layout={layout} options={options} />
        </Field>
    );
}
export default RadioButtonListField;